/* FG Brilho · Theme JS */
(function () {
  'use strict';

  var SHIPPING_THRESHOLD = 150000; // centavos — R$ 1.500,00

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* =========================================================
     Cart Drawer
     ========================================================= */
  var drawer = document.getElementById('fg-cart-drawer');
  var backdrop = document.getElementById('fg-cart-backdrop');

  window.FGCart = {
    open: function () {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      backdrop && backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },
    close: function () {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      backdrop && backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    },
    refresh: function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          window.FGCart._render(cart);
        })
        .catch(function (e) { console.error('FGCart.refresh:', e); });
    },
    _render: function (cart) {
      /* Count badges */
      document.querySelectorAll('#fg-cart-count, #fg-cart-count-mobile').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      var countEl = document.getElementById('fg-drawer-count');
      if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'itens');

      /* Shipping bar */
      var remaining = SHIPPING_THRESHOLD - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price * 100 / SHIPPING_THRESHOLD));
      var shippingMsg = document.getElementById('fg-shipping-msg');
      var shippingRemaining = document.getElementById('fg-shipping-remaining');
      var shippingFill = document.getElementById('fg-shipping-bar-fill');
      if (shippingFill) shippingFill.style.width = pct + '%';
      if (shippingMsg && shippingRemaining) {
        if (remaining <= 0) {
          shippingMsg.innerHTML = '<span style="color:var(--fg-gold);">◆ Você ganhou frete grátis!</span>';
        } else {
          shippingMsg.innerHTML = 'Falta <strong style="color:var(--fg-gold);" id="fg-shipping-remaining">' + formatMoney(remaining) + '</strong> para frete grátis';
        }
      }

      /* Items */
      var itemsEl = document.getElementById('fg-drawer-items');
      if (itemsEl) {
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:20px;padding:60px 0;">'
            + '<p style="font-family:var(--fg-serif);font-size:22px;color:var(--fg-paper-mute);">Seu carrinho está vazio</p>'
            + '<a href="/collections/all" class="fg-btn fg-btn--ghost" onclick="window.FGCart.close()">Explorar joias</a>'
            + '</div>';
        } else {
          itemsEl.innerHTML = cart.items.map(function (item) {
            var variantLine = item.variant_title && item.variant_title !== 'Default Title'
              ? '<span style="font-size:11px;color:var(--fg-paper-mute);">' + item.variant_title + '</span>'
              : '';
            return '<div class="fg-cart-item" data-key="' + item.key + '" style="display:grid;grid-template-columns:80px 1fr;gap:16px;padding:20px 0;border-bottom:1px solid var(--fg-paper-line);">'
              + '<a href="' + item.url + '" style="display:block;aspect-ratio:1/1;overflow:hidden;background:var(--fg-paper-warm);">'
              + '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">'
              + '</a>'
              + '<div style="display:flex;flex-direction:column;gap:6px;">'
              + '<a href="' + item.url + '" style="font-family:var(--fg-serif);font-size:16px;line-height:1.2;color:var(--fg-ink);">' + item.product_title + '</a>'
              + variantLine
              + '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:auto;">'
              + '<div style="display:flex;align-items:center;border:1px solid var(--fg-paper-line);">'
              + '<button type="button" class="fg-cart-qty" data-action="decrease" data-key="' + item.key + '" style="padding:6px 10px;cursor:pointer;border:0;background:transparent;">&#8722;</button>'
              + '<span style="padding:0 8px;font-size:13px;min-width:20px;text-align:center;">' + item.quantity + '</span>'
              + '<button type="button" class="fg-cart-qty" data-action="increase" data-key="' + item.key + '" style="padding:6px 10px;cursor:pointer;border:0;background:transparent;">&#43;</button>'
              + '</div>'
              + '<span style="font-size:14px;font-weight:500;">' + formatMoney(item.final_line_price) + '</span>'
              + '</div>'
              + '<button type="button" class="fg-cart-remove" data-key="' + item.key + '" style="font-size:10px;color:var(--fg-paper-mute);text-align:left;letter-spacing:0.08em;text-transform:uppercase;padding:0;border:0;background:transparent;cursor:pointer;font-family:var(--fg-sans);">Remover</button>'
              + '</div>'
              + '</div>';
          }).join('');
        }
      }

      /* Footer */
      var footEl = document.getElementById('fg-drawer-foot');
      if (footEl) {
        footEl.style.display = cart.item_count > 0 ? '' : 'none';
        if (cart.item_count > 0) {
          var subtotalEl = document.getElementById('fg-drawer-subtotal');
          var totalEl = document.getElementById('fg-drawer-total');
          var installEl = document.getElementById('fg-drawer-installments');
          var discountRow = document.getElementById('fg-drawer-discount-row');
          var discountEl = document.getElementById('fg-drawer-discount');

          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
          if (installEl) {
            var installAmt = Math.round(cart.total_price / 10);
            var pixAmt = Math.round(cart.total_price * 0.95);
            installEl.textContent = 'ou ' + formatMoney(installAmt) + ' em 10x sem juros · ' + formatMoney(pixAmt) + ' à vista no Pix';
          }
          if (discountRow && discountEl && cart.total_discounts > 0) {
            discountRow.style.display = 'flex';
            discountEl.textContent = '-' + formatMoney(cart.total_discounts);
          } else if (discountRow) {
            discountRow.style.display = 'none';
          }
        }
      }
    },
    addItem: function (variantId, qty, callback) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            alert(data.description || 'Não foi possível adicionar o item.');
            return;
          }
          if (callback) callback(data);
          window.FGCart.open();
        })
        .catch(function (e) { console.error('FGCart.addItem:', e); });
    },
    changeItem: function (key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { window.FGCart._render(cart); })
        .catch(function (e) { console.error('FGCart.changeItem:', e); });
    },
  };

  /* Cart toggle buttons */
  document.querySelectorAll('[data-fg-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        window.FGCart.close();
      } else {
        window.FGCart.open();
      }
    });
  });

  /* Cart qty changes & remove in drawer (delegated — works on dynamically built HTML) */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.fg-cart-qty');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.dataset.key;
      var action = qtyBtn.dataset.action;
      var span = qtyBtn.parentElement.querySelector('span');
      var current = parseInt(span ? span.textContent : 1);
      var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      window.FGCart.changeItem(key, newQty);
    }

    var removeBtn = e.target.closest('.fg-cart-remove');
    if (removeBtn) {
      e.preventDefault();
      window.FGCart.changeItem(removeBtn.dataset.key, 0);
    }
  });

  /* Coupon code — applies discount to checkout URL */
  var couponBtn = document.getElementById('fg-coupon-btn');
  var couponInput = document.getElementById('fg-coupon-input');
  if (couponBtn && couponInput) {
    function applyDiscount() {
      var code = couponInput.value.trim().toUpperCase();
      if (!code) return;
      var checkoutBtn = document.getElementById('fg-drawer-checkout');
      if (checkoutBtn) checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(code);
      couponBtn.textContent = '✓ Aplicado';
      couponBtn.style.color = 'var(--fg-gold)';
      couponInput.disabled = true;
      setTimeout(function () {
        couponBtn.textContent = 'Aplicar';
        couponBtn.style.color = '';
        couponInput.disabled = false;
      }, 3500);
    }
    couponBtn.addEventListener('click', applyDiscount);
    couponInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') applyDiscount(); });
  }

  /* Product form intercept — add to drawer instead of redirect */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#fg-product-form');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput) return;
    window.FGCart.addItem(idInput.value, parseInt(qtyInput ? qtyInput.value : 1));
  });

  /* Quick add from cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fgc__quickadd');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.productId;
    if (variantId) window.FGCart.addItem(variantId, 1);
  });

  /* =========================================================
     Variant selector (PDP)
     ========================================================= */
  var variantBtns = document.querySelectorAll('.fg-variant');
  var variantIdInput = document.getElementById('fg-variant-id');

  if (variantBtns.length && variantIdInput) {
    var selectedOptions = {};

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionName = btn.dataset.option;
        var value = btn.dataset.value;
        selectedOptions[optionName] = value;

        document.querySelectorAll('.fg-variant[data-option="' + optionName + '"]').forEach(function (b) {
          b.setAttribute('aria-checked', b.dataset.value === value ? 'true' : 'false');
        });
      });
    });
  }

  /* =========================================================
     Mobile sticky CTA visibility
     ========================================================= */
  var stickyCta = document.getElementById('fg-mobile-cta');
  if (stickyCta && window.innerWidth < 750) {
    stickyCta.style.display = 'flex';
    document.body.classList.add('has-sticky-cta');
  }

  /* =========================================================
     Search panel
     ========================================================= */
  var searchPanel = document.getElementById('fg-search-panel');
  var searchInput = document.getElementById('fg-search-input');

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.setAttribute('aria-hidden', 'false');
    searchPanel.style.opacity = '1';
    searchPanel.style.transform = 'translateY(0)';
    searchPanel.style.pointerEvents = 'auto';
    if (searchInput) { searchInput.focus(); }
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.setAttribute('aria-hidden', 'true');
    searchPanel.style.opacity = '0';
    searchPanel.style.transform = 'translateY(-8px)';
    searchPanel.style.pointerEvents = 'none';
  }

  document.querySelectorAll('[data-fg-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchPanel && searchPanel.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      } else {
        openSearch();
      }
    });
  });

  var searchCloseBtn = document.getElementById('fg-search-close');
  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', closeSearch);
  }

  /* Close search when clicking outside */
  document.addEventListener('click', function (e) {
    if (searchPanel && searchPanel.getAttribute('aria-hidden') === 'false') {
      if (!searchPanel.contains(e.target) && !e.target.closest('[data-fg-search-toggle]')) {
        closeSearch();
      }
    }
  });

  /* =========================================================
     Mobile menu drawer
     ========================================================= */
  var menuDrawer = document.getElementById('fg-menu-drawer');
  var menuPanel = document.getElementById('fg-menu-panel');
  var menuBackdrop = document.getElementById('fg-menu-backdrop');

  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.setAttribute('aria-hidden', 'false');
    menuDrawer.style.pointerEvents = 'auto';
    if (menuBackdrop) menuBackdrop.style.opacity = '1';
    if (menuPanel) menuPanel.style.transform = 'translateX(0)';
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!menuDrawer) return;
    menuDrawer.setAttribute('aria-hidden', 'true');
    menuDrawer.style.pointerEvents = 'none';
    if (menuBackdrop) menuBackdrop.style.opacity = '0';
    if (menuPanel) menuPanel.style.transform = 'translateX(-100%)';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-fg-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (menuDrawer && menuDrawer.getAttribute('aria-hidden') === 'false') {
        closeMenu();
      } else {
        openMenu();
      }
    });
  });

  var menuCloseBtn = document.getElementById('fg-menu-close');
  if (menuCloseBtn) menuCloseBtn.addEventListener('click', closeMenu);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);

  /* =========================================================
     Wishlist — localStorage
     ========================================================= */
  var WISHLIST_KEY = 'fg_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(ids) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function isWished(id) {
    return getWishlist().indexOf(String(id)) > -1;
  }
  function getWishlistData() {
    try { return JSON.parse(localStorage.getItem('fg_wishlist_data') || '[]'); } catch (e) { return []; }
  }

  function toggleWishlist(id, productData) {
    var list = getWishlist();
    var idx = list.indexOf(String(id));
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(String(id));
    }
    saveWishlist(list);

    /* Also persist/remove full product data for the favorites page */
    var dataList = getWishlistData();
    var dataIdx = dataList.findIndex ? dataList.findIndex(function (p) { return String(p.id) === String(id); }) : -1;
    if (dataIdx > -1) {
      dataList.splice(dataIdx, 1);
    } else if (productData) {
      dataList.push(productData);
    }
    try { localStorage.setItem('fg_wishlist_data', JSON.stringify(dataList)); } catch (e) {}
  }
  function updateAllWishBtns() {
    var list = getWishlist();
    var count = list.length;

    /* Update header count badges */
    document.querySelectorAll('#fg-wish-count, #fg-wish-count-mobile').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });

    /* Update individual heart buttons */
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (!id) return;
      var wished = isWished(id);
      btn.classList.toggle('is-wished', wished);
      btn.setAttribute('aria-label', wished ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.productId;
    if (!id) return;

    /* Build product snapshot from button/card data attributes */
    var productData = null;
    if (!isWished(id)) {
      var card = btn.closest('[data-pid]') || btn;
      productData = {
        id: id,
        url: btn.dataset.purl || card.dataset.purl || '',
        title: btn.dataset.ptitle || card.dataset.ptitle || '',
        price: btn.dataset.pprice || card.dataset.pprice || '',
        installment: btn.dataset.pinstallment || card.dataset.pinstallment || '',
        pix: btn.dataset.ppix || card.dataset.ppix || '',
        img: btn.dataset.pimg || card.dataset.pimg || '',
        vid: btn.dataset.pvid || card.dataset.pvid || ''
      };
    }

    toggleWishlist(id, productData);
    updateAllWishBtns();
  });

  updateAllWishBtns();

  /* =========================================================
     Rotating announcement bar
     ========================================================= */
  document.querySelectorAll('[data-fg-announcements]').forEach(function (rotator) {
    var items = rotator.querySelectorAll('.fg-announcement-rotator__item');
    if (!items.length) return;

    var intervalSeconds = parseInt(rotator.getAttribute('data-interval') || '4', 10);
    var interval = Math.max(2, intervalSeconds) * 1000;
    var current = 0;

    rotator.setAttribute('data-fg-announcements-ready', 'true');
    items.forEach(function (item, index) {
      item.classList.toggle('is-active', index === 0);
    });

    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, interval);
  });

  /* =========================================================
     Escape key closes drawer, search and menu
     ========================================================= */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      window.FGCart.close();
      closeSearch();
      closeMenu();
    }
  });

  /* =========================================================
     Carousel — [data-carousel]
     ========================================================= */
  function initCarousel(el) {
    var visible = parseInt(el.getAttribute('data-visible') || '4');
    var track = el.querySelector('[data-carousel-track]');
    var dotsContainer = el.querySelector('[data-carousel-dots]');
    if (!track) return;

    var slides = track.querySelectorAll('.fg-carousel__slide');
    var total = slides.length;
    var current = 0;
    var isMobile = window.innerWidth < 750;

    function getVisible() { return window.innerWidth < 750 ? 1 : (window.innerWidth < 990 ? 2 : visible); }
    function maxIndex() { return Math.max(0, total - getVisible()); }

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var pages = maxIndex() + 1;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.className = 'fg-carousel__dot' + (i === current ? ' fg-carousel__dot--active' : '');
        dot.setAttribute('aria-label', 'Ir para ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () { goTo(parseInt(this.dataset.index)); });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.fg-carousel__dot').forEach(function (dot, i) {
        dot.className = 'fg-carousel__dot' + (i === current ? ' fg-carousel__dot--active' : '');
      });
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, maxIndex()));
      if (window.innerWidth < 750) {
        var viewport = el.querySelector('.fg-carousel__viewport');
        if (viewport && slides[current]) {
          viewport.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
        }
      } else {
        var slideWidth = slides[0] ? slides[0].offsetWidth + 20 : 0;
        track.style.transform = 'translateX(-' + (current * slideWidth) + 'px)';
      }
      updateDots();
    }

    el.addEventListener('fg:prev', function () { goTo(current - 1); });
    el.addEventListener('fg:next', function () { goTo(current + 1); });

    /* Sync dots to native scroll on mobile */
    var viewport = el.querySelector('.fg-carousel__viewport');
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        if (window.innerWidth >= 750) return;
        var idx = 0;
        var minDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - viewport.scrollLeft);
          if (dist < minDist) { minDist = dist; idx = i; }
        });
        current = idx;
        updateDots();
      }, { passive: true });
    }

    buildDots();
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  /* Init cart count on page load */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('#fg-cart-count, #fg-cart-count-mobile').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });

  /* =========================================================
     Scroll-aware sticky header — hide on down, show on up
     ========================================================= */
  (function () {
    var wrapper = document.querySelector('.fg-header-wrapper');
    if (!wrapper) return;
    var lastY = 0;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < 80) {
          wrapper.classList.remove('header-hidden');
        } else if (y > lastY) {
          wrapper.classList.add('header-hidden');
        } else {
          wrapper.classList.remove('header-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  })();

})();
